module.exports = __webpack_public_path__ + "static/react-native-cac2f0ebd877f0b580c71b78fc44ff39.svg";